import Vue from 'vue'
import App from './App.vue'
import Config from './Config.js'
import VModal from 'vue-js-modal'
import Vuelidate from 'vuelidate'

import 'es6-promise/auto'
import {
  library
}
from '@fortawesome/fontawesome-svg-core'
import {
  faWarehouse, faStopwatch, faWrench, faGlobe, faPhone, faEnvelope,
  faArrowRight, faChevronDown, faChevronUp, faMapMarkerAlt, faKey,
  faCertificate, faCrosshairs, faEnvelopeOpenText, faNewspaper
}
from '@fortawesome/free-solid-svg-icons'
import {
  FontAwesomeIcon
}
from '@fortawesome/vue-fontawesome'


import {
  store
}
from './store';


import {
  i18n
}
from './plugins/i18n.js'


library.add(faWarehouse)
library.add(faStopwatch)
library.add(faWrench)
library.add(faGlobe)
library.add(faPhone)
library.add(faEnvelope)
library.add(faArrowRight)
library.add(faChevronUp)
library.add(faChevronDown)
library.add(faMapMarkerAlt)
library.add(faKey)
library.add(faCertificate)
library.add(faCrosshairs)
library.add(faEnvelopeOpenText)


Vue.use(Vuelidate)
Vue.use(require('vue-moment'));
Vue.use(VModal)


Vue.component('font-awesome-icon', FontAwesomeIcon)

export const serverBus = new Vue();

window.vmcontact = new Vue({
  el: '#rewaco-contact',
  store,
  i18n,
  render: h => h(App)
}).$mount('#rewaco-contact')
